import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import {
  CustomerAnalysisResponse,
  CustomerAnalysisRequest,
} from "@/core/customers/entities/CustomerAnalysis";
import CustomerAnalysisRepository from "@/core/customers/repositories/CustomerAnalysisRepository";

export default class GetCustomerAnalysisUseCase {
  constructor(
    private readonly customerAnalysisRepository: CustomerAnalysisRepository
  ) {}

  /**
   * Executes the get customer analysis use case.
   *
   * @param request - The customer analysis request containing businessKey
   * @returns A promise resolving with CustomerAnalysisResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(
    request: CustomerAnalysisRequest
  ): Promise<CustomerAnalysisResponse> {
    try {
      return await this.customerAnalysisRepository.getCustomerAnalysis(request);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
